import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import InfoRowItemWithActions from '../InfoRowItemWithActions/InfoRowItemWithActions';

export type SelectSocieteCardProps = {
    title: string;
    company?: {
        name: string;
        identifier: string;
    };
    icon: IconDefinition;
    noResultLabel?: string;
    onClick: () => void;
};

export const SelectSocieteCard: React.FunctionComponent<SelectSocieteCardProps> = function (props) {
    const { title, company, icon, noResultLabel = 'Société non définie', onClick } = props;
    const { palette } = useTheme();

    return (
        <Box>
            <Typography variant="l2dsubtitles">{title}</Typography>
            <InfoRowItemWithActions
                info={
                    company ? (
                        <>
                            <Typography variant="l2dsubtitles">{company.name}</Typography>
                            <Typography variant="l2dcaption">{company.identifier}</Typography>
                        </>
                    ) : (
                        <Typography
                            variant="l2dsubtitles"
                            sx={{ color: palette.warning.main }}
                        >
                            {noResultLabel}
                        </Typography>
                    )
                }
                icon={icon}
                rowSx={{ padding: '25px 28px 25px 35px' }}
                singleActionOnClick={onClick}
            />
        </Box>
    );
};
